import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanListPageUI from './LoanListPageUI.js'

class LoanListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loanList: null,
    }
  }

  render() {
    return (
      <LoanListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loanList={this.state.loanList}
        onRefreshClick={this.onRefreshClick}
        onTypeChange={this.onTypeChange}
        openOrClosed='closed'
        pageTitle='Rejected loans'
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    const queryParameters = new URLSearchParams(window.location.search)
    this.getLoans(context, context.filter)
  }

  onTypeChange = (type) => {
    this.getLoans(this.props.context, type)
  }

  getLoans(context, stp) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans`,
      cacheKey: CacheKeys.AllLoans('closed', stp),
      callback: this.getLoansCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, { openOrClosed: 'closed', stp: stp === 'stp' ? true : false })
  }

  getLoansCallback = (response) => {
    this.setState({ errorList: response.errorList, loanList: response.loanList })
  }

  onRefreshClick = () => {
    /*
    this.state.loanList.forEach(loan => {
      CacheManager.removeObject(CacheKeys.BillsByLoanId(loan.loanId))
      CacheManager.removeObject(CacheKeys.Orders(loan.loanId, ''))
      if (loan.termSheet)
        CacheManager.removeObject(CacheKeys.Order(loan.termSheet.estimateId))
    })
    */
    CacheManager.removeObject(CacheKeys.AllLoans('closed', this.props.context.filter))
    this.setState({ loanList: null, errorList: null })
    this.getLoans(this.props.context, this.props.context.filter)
  }
}

export default LoanListPageSF
